export const FORM_LAYOUT = {
  GRID: 'grid',
  STACK: 'stack',
};
